<template>
    <div class="LoginLogo"><img src="/CmsData/imagefolder/Loginlogo.png" srcset="/CmsData/imagefolder/LoginlogoRetina.png 2x" alt="" /></div>	
    <div class="Login">
        <div class="LoginPanel">
            <form class="Form">
                <fieldset>
                    <legend>Benvenuto nel portale dei manutentori Conad</legend>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label class="Username">Username</label>
                            <input type="text" id="" name="" placeholder="Inserisci il tuo username" v-model="this.username">
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label class="Password">Password</label>
                            <input type="password" id="" name="" placeholder="Inserisci la tua password" v-model="this.password" @keypress.enter="this.doLogin">
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <div class="Button">
                                <input type="button" @click="this.doLogin" id="" name="" value="Accedi" >
                            </div>
                        </div>
                    </div>
                    <div class="loader" v-show="this.isLoading"></div> 
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputButton">
                            <span class="errorMsg">{{errorMsg}}</span>
                        </div>
                    </div>    
                </fieldset>
            </form>
            <!-- <div class="RecoverOpenButton"><a href="login2.asp">Recupera password</a></div> -->
        </div>
    </div>
    <div class="Powered"><span>Powered by Kairos Software</span></div>	
</template>

<script>
export default {
    name: "Login",
    mounted: function(){
        document.body.classList.add('LoginPage');
        document.body.classList.add('nojs');
    },
    data(){
        return {
            username: "",
            password: "",
            isLoading: false,            
            errorMsg: ""
        }
    },
    methods: {
        doLogin: function(){           
            this.isLoading = true;
            this.$store.dispatch({
                type: 'login',               
                username: this.username,
                password: this.password,
                apikey: process.env.VUE_APP_APIKEY,
                idCompany: process.env.VUE_APP_ID_COMPANY,
                idPortale: process.env.VUE_APP_ID_PORTALE             
            }).then(
                (data) => {
                    this.isLoading = false;
                    if(data[0]){
                        this.$router.push("/default");    
                    }
                    else if(!data[0] && data[1]){
                    
                        this.errorMsg = data[1];
                    }
                    else{
                        this.errorMsg =  "Autenticazione fallita! Username e/o Password errati."; 
                    }                                  
                },
                (error) => {                                             
                    this.isLoading = false;
                    this.errorMsg = "Autenticazione fallita! Username e/o Password errati.";                    
                }
            );
        }
    }
}
</script>
<style>

.errorMsg{
    color: #ff0000;
}

</style>